import clsx from "clsx";
import Link from "next/link";
import { useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import useViewport, { Viewport } from "../../hooks/useViewport";

import NewsPostItem from "../news-post-item";

import styles from "./next-story.module.scss";

const NextStory = ({ articles }) => {
  const device = useViewport();
  const [currentSlide, setCurrentSlide] = useState(0);

  if (!articles || articles.length === 0) return null;

  if (device === Viewport.PHONE) {
    return (
      <>
        <div className={clsx(styles.Border, styles.NextStoryMobile)}>
          <p className={clsx(styles.NextStoryHeading)}>Next Story</p>

          <Link href={`/news/${articles[articles.length - 1].slug}`} passHref>
            <a className={styles.NextStoryLink}>
              {articles[articles.length - 1].title}
            </a>
          </Link>
        </div>

        <div className={clsx(styles.Border, styles.NextStoryMobile)}>
          <p className={clsx(styles.NextStoryHeading)}>
            Continued news &amp; stories
          </p>

          <Carousel
            showArrows={false}
            showIndicators={false}
            showThumbs={false}
            showStatus={false}
            autoPlay={false}
            selectedItem={currentSlide}
            swipeScrollTolerance={20}
            preventMovementUntilSwipeScrollTolerance
            onChange={(index) => setCurrentSlide(index)}
          >
            {articles.slice(0, 2).map((article) => (
              <div key={article.slug}>
                <NewsPostItem className={styles.Post} post={article} medium />
              </div>
            ))}
          </Carousel>

          <div className={styles.CarouselButtons}>
            {articles.slice(0, 2).map((post, index) => (
              <button
                key={post.slug}
                onClick={() => setCurrentSlide(index)}
                className={clsx(
                  styles.CarouselButton,
                  index === currentSlide && styles.Active
                )}
              ></button>
            ))}
          </div>
        </div>
      </>
    );
  }

  return (
    <div className="md:flex md:flex-row justify-between items-start gap-16 p-4 md:p-0">
      <div className={styles.Border}>
        <p className={clsx("mt-4 mb-8", styles.NextStoryHeading)}>
          Continued news &amp; stories
        </p>
        <div className={styles.Scroll}>
          <div className={styles.Posts}>
            {articles.slice(0, 2).map((article) => (
              <NewsPostItem
                className={styles.Post}
                key={article.slug}
                post={article}
                medium
              />
            ))}
          </div>
        </div>
      </div>
      <div
        className={clsx(
          styles.Border,
          "hidden md:block i w-full md:w-auto md:flex-1"
        )}
      >
        <p className={clsx("mt-4 mb-8", styles.NextStoryHeading)}>Next Story</p>

        <Link href={`/news/${articles[articles.length - 1].slug}`} passHref>
          <a className={styles.NextStoryLink}>
            {articles[articles.length - 1].title}
          </a>
        </Link>
      </div>
    </div>
  );
};

export default NextStory;
